/**
 * Decide se o polling de mensagens não lidas deve avisar o usuário.
 *
 * Existe separado do componente por causa do bug que motivou o arquivo: o
 * layout lia `unreadData?.count ?? 0`, e o efeito rodava UMA vez antes da
 * resposta chegar. O `?? 0` virava a referência, a primeira resposta real
 * (ex: 159) era lida como "159 mensagens novas" e o toast disparava em todo
 * carregamento de página — em um workspace que não recebia mensagem havia
 * uma semana. A regra crítica é a primeira: enquanto a resposta não chega,
 * NADA vira referência.
 */
export type UnreadDelta = {
  /** Quantas avisar. `null` = não avisar. */
  notifyCount: number | null;
  /** Nova referência para a próxima checagem. */
  nextPrevious: number | null;
};

export function evaluateUnreadDelta(args: {
  /** Referência da checagem anterior. `null` = ainda não há. */
  previous: number | null;
  /** Total atual. `undefined` = resposta ainda em voo. */
  current: number | undefined;
  /** O usuário já está na Caixa de Entrada? */
  onInbox: boolean;
}): UnreadDelta {
  const { previous, current, onInbox } = args;

  // Resposta ainda não chegou: preserva a referência anterior.
  if (current === undefined) return { notifyCount: null, nextPrevious: previous };

  // Primeira leitura real: vira referência, sem avisar.
  if (previous === null) return { notifyCount: null, nextPrevious: current };

  // Já está lendo a caixa — o aviso seria ruído.
  if (onInbox) return { notifyCount: null, nextPrevious: current };

  const diff = current - previous;
  return { notifyCount: diff > 0 ? diff : null, nextPrevious: current };
}
